import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { normalizeLocationHash } from '../hashTabRouting';

type UseTabHashRoutingOptions = {
  enabled: boolean;
  hashTabMap: Record<string, number>;
  activeTab: number;
  setActiveTab: (index: number) => void;
};

/** Syncs active tab index from the URL hash (e.g. `#matrix` → tab 1). */
export const useTabHashRouting = ({
  enabled,
  hashTabMap,
  activeTab,
  setActiveTab,
}: UseTabHashRoutingOptions) => {
  const { hash } = useLocation();
  const normalizedHash = useMemo(() => normalizeLocationHash(hash), [hash]);

  useEffect(() => {
    if (!enabled || !normalizedHash) {
      return;
    }

    const tabIndex = hashTabMap[normalizedHash];
    if (tabIndex !== undefined && tabIndex !== activeTab) {
      setActiveTab(tabIndex);
    }
  }, [enabled, normalizedHash, hashTabMap, activeTab, setActiveTab]);
};
